export default __webpack_public_path__ + "static/media/RMPMLogo_FullColor.be8f5cd1.png";